import {
  Grid,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Box,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { WriteMessage } from "./WriteMessage";
import { Inbox } from "./Inbox";
import { Sent } from "./Sent";
import { Trash } from "./Trash";

export const Message: React.FC<any> = React.memo((props) => {
  // Initially setting the inbox as the selected component
  const [selectedComponent, setSelectedComponent] = useState<JSX.Element>(
    <Inbox />
  );
  const [showInboxIcons, setShowInboxIcons] = useState(true);
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
  };

  const handleListItemClick = (component: JSX.Element, showIcons: boolean) => {
    setSelectedComponent(component);
    setShowInboxIcons(showIcons);
  };

  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
            Messages
          </Typography>
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Show icons conditionally based on the selected component */}
            {showInboxIcons && (
              <>
                <Tooltip title="Show All Messages">
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      marginRight: "8px",
                      borderRadius: "2px",
                    }}
                  >
                    <WSIcons.FormatListBulletedIcon />{" "}
                    {/* Replace with your actual icon */}
                  </IconButton>
                </Tooltip>
                <Tooltip title="Show UnRead Message only">
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      marginRight: "8px",
                      borderRadius: "2px",
                    }}
                  >
                    <WSIcons.VisibilityOffIcon />{" "}
                    {/* Replace with your actual icon */}
                  </IconButton>
                </Tooltip>
              </>
            )}
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      {/* Main Content Section */}
      <Grid item container sx={{ flex: 1 }}>
        {/* Sidebar */}
        <Grid item sx={{ width: "250px", borderRight: "1px solid #ccc" }}>
          <List>
            <ListItem
              button
              onClick={() => handleListItemClick(<WriteMessage />, false)}
              selected={selectedComponent?.type === WriteMessage}
            >
              <ListItemIcon>
                <WSIcons.EditNoteIcon />
              </ListItemIcon>
              <ListItemText primary="Write Message" />
            </ListItem>

            <ListItem
              button
              onClick={() => handleListItemClick(<Inbox />, true)}
              selected={selectedComponent?.type === Inbox}
            >
              <ListItemIcon>
                <WSIcons.InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Inbox" />
            </ListItem>

            <ListItem
              button
              onClick={() => handleListItemClick(<Sent />, true)}
              selected={selectedComponent?.type === Sent}
            >
              <ListItemIcon>
                <WSIcons.SendIcon />
              </ListItemIcon>
              <ListItemText primary="Sent" />
            </ListItem>

            <ListItem
              button
              onClick={() => handleListItemClick(<Trash />, true)}
              selected={selectedComponent?.type === Trash}
            >
              <ListItemIcon>
                <WSIcons.DeleteIcon />
              </ListItemIcon>
              <ListItemText primary="Trash" />
            </ListItem>
          </List>
        </Grid>

        {/* Main Content Area */}
        <Grid item xs sx={{ padding: "16px" }}>
          {/* Render selected component */}
          {selectedComponent}
        </Grid>
      </Grid>
      <Grid
        bgcolor="#333"
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        <Grid display="flex" ml="auto" gap={4}>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Mark As Unread
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Mark As Read
          </Button>
          <Button variant="contained" color="success">
            Read
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
            onClick={() => handleClick("/")}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
